import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import {
	Box,
	Button,
	Card,
	debounce, // Add this import
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { Container } from "@mui/system";
import { useCallback, useState } from "react";
import { Helmet } from "react-helmet-async";
import CommonDateRangePicker from "./CommonDateRangePicker";

type IProps = {
	children: React.ReactNode;
	componentChildren?: React.ReactNode;
	handleSearchFun?: (value: string) => void;
	handleSelectStatus?: (selectValue: string) => void;
	handleSelectStatus1?: (selectValue: string) => void;
	handleBtnForModalFun?: () => void;
	statusOptions?: { id: string; name: string }[];
	statusOptions1?: { id: string; name: string }[];
	helmetTitle?: string;
	headerTitle?: string;
	showCardHeader?: boolean;
	showDateRange?: boolean;
	showSearch?: boolean;
	showStatus?: boolean;
	showStatus1?: boolean;
	showButton?: boolean;
	btnText?: string;
	searchPlaceHolder?: string;
	statusLabel?: string;
	statusLabel1?: string;
	handleDateRange?: (date: { start_date: string; end_date: string }) => void;
};
const CommCard = ({
	children,
	handleSearchFun,
	handleSelectStatus,
	handleSelectStatus1,
	statusOptions,
	helmetTitle,
	headerTitle,
	showCardHeader,
	handleDateRange,
	showDateRange,
	showSearch,
	showStatus,
	showButton,
	handleBtnForModalFun,
	btnText,
	statusLabel,
	searchPlaceHolder,
	statusLabel1,
	showStatus1,
	statusOptions1,
	componentChildren,
}: IProps) => {
	const [statusValue, setStatusValue] = useState("");
	const [statusValue1, setStatusValue1] = useState("");
	const [searchValue, setSearchValue] = useState("");
	const handleSearch = useCallback(
		debounce((value) => {
			handleSearchFun && handleSearchFun(value);
		}, 1000),
		[]
	);
	const handleClearSearch = () => {
		setSearchValue("");
		if (typeof (handleSearch as any)?.clear === "function") {
			(handleSearch as any).clear();
		}
		handleSearchFun && handleSearchFun("");
	};
	return (
		<>
			<Helmet>
				<title>{helmetTitle || "BTTF"}</title>
			</Helmet>

			<Container sx={{ mt: 4 }} maxWidth='xl'>
				<Grid
					container
					direction='row'
					justifyContent='center'
					alignItems='stretch'
					spacing={3}
				>
					<Grid item xs={12}>
						<Card>
							{showCardHeader && (
								<>
									<Grid
										container
										spacing={2}
										alignItems='center'
										sx={{ px: 2 }}
									>
										{headerTitle && (
											<Grid item xs={12} sm={4} md={3}>
												<h3>{headerTitle || ""}</h3>
											</Grid>
										)}

										<Grid item xs={12} sm={8} md={9}>
											<Box
												sx={{
													display: "flex",
													justifyContent: "end",
													alignItems: "center",
													flexWrap: {
														xs: "wrap",
														sm: "nowrap",
													}, // Wrap on small screens, inline on larger screens
													gap: 2,
												}}
											>
												{showDateRange && (
													<Grid
														item
														xs={12}
														sm={12}
														md={6}
														lg={6}
														xl={6}
													>
														<CommonDateRangePicker
															handleDateRange={
																handleDateRange
															}
														/>
													</Grid>
												)}

												{/* Search Field */}
												{showSearch && (
													<TextField
														variant='outlined'
														placeholder={
															searchPlaceHolder ||
															"Search..."
														}
														size='small'
														value={searchValue}
														onChange={(e) => {
															const val = e.target.value;
															setSearchValue(val);
															handleSearch(val.trim());
														}}
														InputProps={{
															startAdornment: (
																<InputAdornment position='start'>
																	<SearchIcon fontSize='small' />
																</InputAdornment>
															),
															endAdornment: searchValue ? (
																<InputAdornment position='end'>
																	<IconButton
																		type='button'
																		size='small'
																		aria-label='clear search'
																		onClick={handleClearSearch}
																		edge='end'
																		sx={{ p: 0.5 }}
																	>
																		<ClearIcon fontSize='small' />
																	</IconButton>
																</InputAdornment>
															) : null,
														}}
														sx={{
															flex: 1,
															minWidth: "150px",
															maxWidth: "300px",
														}}
													/>
												)}

												{/* Status Filter */}

												{showStatus && (
													<FormControl
														sx={{
															flex: 1,
															minWidth: "150px",
															maxWidth: "200px",
														}}
														size='small'
													>
														<InputLabel>
															{statusLabel ||
																"Status"}
														</InputLabel>
														<Select
															value={statusValue}
															onChange={(e) => {
																setStatusValue(
																	e.target
																		.value
																);
																handleSelectStatus?.(
																	e.target
																		.value
																);
															}}
															label={
																statusLabel ||
																"Status"
															}
														>
															{statusOptions?.length &&
																statusOptions.map(
																	(
																		statusOption
																	) => (
																		<MenuItem
																			key={
																				statusOption.id
																			}
																			value={
																				statusOption.id
																			}
																		>
																			{
																				statusOption.name
																			}
																		</MenuItem>
																	)
																)}
														</Select>
													</FormControl>
												)}
												{showStatus1 && (
													<FormControl
														sx={{
															flex: 1,
															minWidth: "150px",
															maxWidth: "200px",
														}}
														size='small'
													>
														<InputLabel>
															{statusLabel1 ||
																"Status"}
														</InputLabel>
														<Select
															value={statusValue1}
															onChange={(e) => {
																setStatusValue1(
																	e.target
																		.value
																);
																handleSelectStatus1?.(
																	e.target
																		.value
																);
															}}
															label={
																statusLabel1 ||
																"Status"
															}
														>
															{statusOptions1?.length &&
																statusOptions1.map(
																	(
																		statusOption
																	) => (
																		<MenuItem
																			key={
																				statusOption.id
																			}
																			value={
																				statusOption.id
																			}
																		>
																			{
																				statusOption.name
																			}
																		</MenuItem>
																	)
																)}
														</Select>
													</FormControl>
												)}

												{showButton && (
													<Button
														onClick={() =>
															handleBtnForModalFun &&
															handleBtnForModalFun()
														}
														variant='contained'
													>
														{btnText || ""}
													</Button>
												)}

												{componentChildren}
											</Box>
										</Grid>
									</Grid>
									<Divider />
								</>
							)}

							{children}
						</Card>
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default CommCard;
